import { LandingContent } from "./types";
import {
  GiMirrorMirror,
  GiSparkles,
  GiStopwatch,
  GiNotebook,
  GiChatBubble,
} from "react-icons/gi";
import { FaQuestion } from "react-icons/fa";
import cosmeticsImage from "../../assets/images/cosmetics.jpg";


export const cosmeticsContent: LandingContent = {
  seo: {
    title: "szépségiparban dolgozóknak időpontfoglaló egyszerűen és gyorsan | Wobble",
    description:
      "Online időpontfoglaló rendszer kozmetikusoknak, szépségszalonoknak és esztétikai kezelést végző szakembereknek. Növeld a vendégélményt és spórolj időt a Wobble-lel!",
    ogTitle: "Wobble - Időpontfoglaló rendszer szépségiparban dolgozóknak",
    ogDescription:
      "Modern online foglalási megoldás, amely segít abban, hogy a fókuszban a vendégeid maradjanak, ne az adminisztráció.",
    keywords: "kozmetikus, szépségszalon, időpontfoglalás, fodrászok, körmösök, tetoválok, online foglalás, szépségipar, Wobble",
    image: "../assets/idopontfoglalo-rendszer-szepsegiparban.png",
  },
  header: {
    heading: "Professzionális időpontfoglalás kozmetikusoknak, körmösöknek, fodrászoknak, tetoválóknak",
    subheading:
      "Könnyítsd meg a vendégeid számára az időpontfoglalást, és szabadulj meg a felesleges adminisztrációtól.",
    highlightText: "Wobble időpontfoglaló rendszer szépségipari szakembereknek",
  },
  problems: {
    title: "Ismerős kihívások a mindennapokban?",
    features: [
      { icon: GiNotebook, text: "Időpontok vezetése jegyzetfüzetben vagy Excelben?" },
      { icon: GiChatBubble, text: "Sok üzenetváltás egy-egy foglalás miatt?" },
      { icon: GiStopwatch, text: "Sokat várnak visszajelzésre a vendégek, nem vagy elérhető mikor ők foglalnának?" },
      { icon: FaQuestion, text: "Ismétlődő kérdések foglalásokról, árakról, szabad időpontokról?" },
      { icon: GiStopwatch, text: "Nem azonnal válaszolsz vagy veszed fel a telefont, emiatt ügyfeleket veszítesz?" },
    ],
    summaryText:
      "A Wobble segít rendet teremteni - automatizálj, és fókuszálj arra, amit szeretsz: a szépítésre!",
    cta: {
      href: "https://app.wobble.hu/signup_page",
      label: "Kipróbálom ingyen",
    },
    imageSrc: cosmeticsImage,
    imageAlt: "Kozmetikus időpontfoglalás",
  },
  whyDigitalize: {
    title: "Miért jó, ha digitalizálsz?",
    features: [
      { icon: GiMirrorMirror, text: "A vendégek ma már online keresnek és foglalnak" },
      { icon: GiStopwatch, text: "Foglalások elérhetőek 0-24, még alvás közben is" },
      { icon: GiChatBubble, text: "Automatikus emlékeztetők csökkentik az elfelejtett időpontokat" },
      { icon: GiNotebook, text: "Egyszerűen nyomon követhető kezelések, időpontok" },
      { icon: GiSparkles, text: "Szolgáltatások, időtartamok és szünetek testreszabása néhány kattintással" },
    ],
  },
  whyTheyLove: {
    title: "Hogyan könnyíti meg a munkád a Wobble?",
    imageSrc: "../assets/idopontfoglalo-rendszer-szepsegiparban.png",
    imageAlt: "Időpontfoglaló rendszer kozmetikusoknak",
    features: [
      { icon: GiMirrorMirror, text: "Szép és könnyen használható foglalási felület" },
      { icon: GiSparkles, text: "Szolgáltatások kezelése, csomagok és extra opciók beállítása, kérdőív már a foglaláskor" },
      { icon: GiStopwatch, text: "Automatikus visszaigazolás és emlékeztető e-mailben" },
      { icon: GiChatBubble, text: "Vendégértékelés a foglalási oldaladon" },
      { icon: GiNotebook, text: "Gyors adminisztráció - több idő a vendégekre" },
      { icon: GiNotebook, text: "Bizalomépítő online jelenlét, blogolási lehetőség" },
    ],
  },
  trial: {
    title: "💆 Próbáld ki 30 napig ingyen!",
    subtitle: "Nincs szükség kártyaadatra - csak regisztrálj, és élvezd az egyszerű foglaláskezelést.",
    cta: {
      href: "https://app.wobble.hu/signup_page",
      label: "Regisztrálok most",
    },
  },
};
